export const text_allpage_bwccore_eng = {
    Full_Name: {
        Xpos:50,
        Ypos:976,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Name Surname: ',
    },
    HN: {
        Xpos:50,
        Ypos:995,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'HN Number: ',
    },
    Gender: {
        Xpos:50,
        Ypos:1015,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Gender: ',
    },
    Date_of_Birth: {
        Xpos:50,
        Ypos:1034,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Date of Birth: ',
    },
    Report_Date: {
        Xpos:50,
        Ypos:1053.5,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Report Date: ',
    },
    Collection_Date: {
        Xpos:50,
        Ypos:1073,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Sample Collection Date: ',
    }    
}

export const text_allpage_bwccore_thai = {
    Full_Name: {
        Xpos:50,
        Ypos:976,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Name Surname: ',
    },
    HN: {
        Xpos:50,
        Ypos:995,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'HN Number: ',
    },
    Gender: {
        Xpos:50,
        Ypos:1015,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Gender: ',
    },
    Date_of_Birth: {
        Xpos:50,
        Ypos:1034,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Date of Birth: ',
    },
    Report_Date: {
        Xpos:50,
        Ypos:1053.5,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Report Date: ',
    },
    Collection_Date: {
        Xpos:50,
        Ypos:1073,
        fontSize:15,
        fontWeight: 400,
        color: '#000000',
        format: 'Sample Collection Date: ',
    }
}